import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=18d8bd2e&"
import script from "./Pagamento.vue?vue&type=script&lang=js&"
export * from "./Pagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports